"use client"; // Error boundaries must be Client Components

import UnknownError from "@/components/Error/UnknownError";

export default function Error() {
  return <UnknownError />;
}
